module.exports = __webpack_public_path__ + "static/media/perfect-circle-cry.1210e217.ogg";